import * as React from "react";
import { forwardRef } from "react";
const SvgRadioChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9439_16640)" }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.5, style: {
  fill: "var(--neutral-text-weak)",
  stroke: "var(--neutral-border)"
}, fillOpacity: 0.16 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 4, style: {
  fill: "var(--neutral-text)"
} })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9439_16640" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const ForwardRef = forwardRef(SvgRadioChecked);
export { ForwardRef as ReactComponent };
